// src/pages/Login.jsx

import { useState } from "react";
import { loginUser } from "../firebase/auth";
import { Link } from "react-router-dom";
import { theme } from "../utils/theme";

const C = theme.colors;

export default function Login() {
  const [email, setEmail]     = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await loginUser(email, password);
      // AuthContext will automatically update user state
    } catch (err) {
      setError(err.code === "auth/invalid-credential" ? "Invalid email or password." : err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: theme.fonts.sans }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap'); *{box-sizing:border-box;margin:0;padding:0;}`}</style>
      <div style={{ width: "100%", maxWidth: 420, padding: 24 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 24, fontWeight: 700, color: C.text, marginBottom: 4 }}>Pankaj Computers Lifewellness</div>
          <div style={{ fontSize: 14, color: C.muted }}>Skill Training Institute · Attendance System</div>
        </div>
        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 28 }}>
          <div style={{ fontSize: 18, fontWeight: 600, color: C.text, marginBottom: 20 }}>Sign in</div>
          {error && <div style={{ background: C.redSoft, border: `1px solid ${C.red}22`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.red }}>{error}</div>}
          <form onSubmit={submit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, color: C.muted, display: "block", marginBottom: 6, fontWeight: 500 }}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="admin@institute.in"
                style={{ width: "100%", background: "#F9FAFB", border: `1px solid ${C.border}`, borderRadius: 9, padding: "10px 13px", fontSize: 14, color: C.text, outline: "none", fontFamily: theme.fonts.sans }} />
            </div>
            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 13, color: C.muted, display: "block", marginBottom: 6, fontWeight: 500 }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••"
                style={{ width: "100%", background: "#F9FAFB", border: `1px solid ${C.border}`, borderRadius: 9, padding: "10px 13px", fontSize: 14, color: C.text, outline: "none", fontFamily: theme.fonts.sans }} />
            </div>
            <button type="submit" disabled={loading} style={{ width: "100%", padding: 13, borderRadius: 10, background: C.accent, color: "#fff", border: "none", fontSize: 15, fontWeight: 600, cursor: loading ? "wait" : "pointer" }}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div style={{ marginTop: 24, textAlign: "center" }}>
          </div>
          </div>
          </div>
          </div>
          );
          }
